import { SearchField, LazySearchField } from 'components/common/SearchField';
import { useTranslator } from 'hooks/translator';
import { SetState } from 'types/react';

import { Box } from '@mui/material';

type MenuSearchProps = {
  filter: string
  setFilter: SetState<string>
  setCurrentFilter: SetState<string>
  disableFilter: boolean
  loading: boolean
  lazy: boolean
  onChange: (e: React.SyntheticEvent) => void
}

const MenuBarSearch = ({filter, setFilter, setCurrentFilter, disableFilter, loading, onChange, lazy}: MenuSearchProps) => {
  const { t } = useTranslator()

  const searchProps = {
    autoFocus: true,
    value: filter,
    setValue: setFilter,
    setCurrentValue: setCurrentFilter,
    placeholder: t('filter.search') || "",
    loading: loading,
    onChange: onChange,
  }

  if (!disableFilter) {
    return (
      <Box style={{paddingLeft: "10px", paddingRight: "10px", width: "300px", alignSelf: "start"}} >
        {lazy ? <LazySearchField {...searchProps}/> : <SearchField {...searchProps}/>}
      </Box>
    )
  } else return null
}

export default MenuBarSearch